// extracted by mini-css-extract-plugin
module.exports = {"item-icon":"styles_item-icon__xIaC4","itemIcon":"styles_item-icon__xIaC4","list":"styles_list__nqkUA","settings":"styles_settings__zXQa_"};